import type { HDDatetime } from '../util/DateTime.js';
import type { HDBaseResponse, HDResponseData } from './BaseResponse.js';

export enum HDDivisionType {
	SEASON = 1, // base divisionId for season (found in divisionInfo and not in divisions)
	REGULAR = 11, // regular season
	PLAYOFF = 12, // base divisionId for playoffs
	GROUP = 21, // group stage
	PLAYOFF_STAGE_CALCULATED = 22, // includes semifinals, finals (same as PLAYOFF_STAGE but with isCalculated = true. Not sure what that means)
	PLAYOFF_STAGE = 30, // includes semifinals, finals
	PLAYOFF_SUBSTAGE = 40 // includes semifinal1, semifinal2, final
}

export interface HDDivision {
	id: number;
	divisionName: string;
	divisionType: HDDivisionType;
	teams: number[];
	isCalculated: boolean;
	permalinks: string[];
}

export interface HDDivisionInfo extends HDDivision {
	durationFrom: HDDatetime;
	durationTo: HDDatetime;
	minRound: number;
	maxRound: number;
	currentRound: number;
}

export interface HDTeam {
	id: number;
	shortname: string;
	longname: string;
	clubCode: string;
	teamCode: string;
	leagueCode: string;
}

export interface HDDivisionInfoResponseData extends HDResponseData {
	divisionInfo: HDDivisionInfo;
	divisions: HDDivision[];
	teams: HDTeam[];
}

export type HDDivisionInfoResponse = HDBaseResponse<HDDivisionInfoResponseData>;
